<template>
  <div class="col l3 m6 s12">
      <div class="card">
        
      
          <h6 class="header_box">{{ data.subject.name }}</h6>
          <div class="info_box">
            <p><i class="material-icons left">date_range</i> {{ data.date }}</p>
            <p><i class="material-icons left">schedule</i>from {{ data.start_time }} to {{ data.end_time }}</p>
          </div>
          <div class="next_box">
            <p class="red-text" v-if="data.next_day!=0">In Next {{ data.next_day }} Days</p>
            <router-link :to="'/exam/'+data.id" class="red-text" v-if="data.next_day==0 && data.already_taken==false && is_time_valid">Enter Exam</router-link>
            <router-link :to="'/exam-detail/'+data.id" class="red-text" v-if="data.next_day==0 && data.already_taken==true">View Exam Result</router-link>
          </div>
    
        
      </div>
    </div>
</template>
<script>
import { validTime } from '@/misc/timemanage.js';
export default {
    props:["data"],
    computed: {
        is_time_valid()
        {
          if (this.current_time)
          {
              return validTime(this.data,this.current_time);
          }
          else 
          {
              return false;
          }
           
       },
       current_time()
       {
           return this.$store.getters.current_time;
       }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/colors.scss";

    .card,.card-title
    {
        border-radius: 20px;
    }

    .card:hover 
    {
        transition: 5s; 
        transform: scale(1.2);
    }

    .header_box 
    {
        border-radius: 20px 20px 0px 0px;
        height:50px;
        background:#7b0c0c;
        color:white;
        text-align:center;
        line-height:50px;
    }

    .info_box
    {
    
        padding-left:10px;
        padding-right:10px;
    }

    .next_box 
    {
        padding-bottom:5px;
        text-align:center;
    }


</style>